import { gql } from "@apollo/client";

export const getDistributionsListQuery = gql`
    query getDistributionsList(
        $releaseId: Int
        $limit: Int = 100000
        $page: Int!
        $cursor: Int
        $distributionAction: String
        $orderBy: DistributionJobOrderByInput = { createdAt: desc }
    ) {
        listDistributions(
            releaseId: $releaseId
            page: $page
            elementsPerPage: $limit
            cursor: $cursor
            distributionAction: $distributionAction
            orderBy: $orderBy
        ) {
            posts {
                releaseName
                releaseId
                client {
                    name
                    isApple
                    enableNewXmlTemplate
                    id
                }
                territory {
                    name
                    id
                }
                logFilePath
                isTakedown
                isMetadataUpdated
                isVideoDistribution
                distributionAction
                takedownLogs
                status
                progress
                timestamp
                videoIsrc
                trackIsrc
                id
                processedOn
                finishedOn
            }
            meta {
                resultCount
                nodeCount
                currentPage
                totalPages
                prevCursor
                nextCursor
            }
        }
    }
`;

// TODO(RCMS-1446): drop once `DistributeJob` exposes `releaseUpc` and read it from `getDistributionJobQuery`.
export const getDistributionReleaseUpcQuery = gql`
    query getDistributionReleaseUpc($id: Int!) {
        release(where: { id: $id }) {
            id
            upc
        }
    }
`;

export const getDistributionJobQuery = gql`
    query getDistributionJob($id: Int!) {
        getDistributionJob(id: $id) {
            id
            releaseId
            releaseName
            client {
                name
                isApple
                id
            }
            territory {
                id
                name
            }
            status
            progress
            timestamp
            logFilePath
            takedownLogs
            processedOn
            finishedOn
            message
            isMetadataUpdated
            isVideoDistribution
            isTakedown
            distributionAction
            videoIsrc
            trackIsrc
            videoFormat
            packageSizeBytes
        }
    }
`;
